/**
 * useRegistroDeRetornoDeLogin — GUPM-335.
 *
 * Quando o login falha na Microsoft (consentimento negado, conta bloqueada,
 * tenant errado) ou no GoTrue (trigger de signup recusando), o navegador volta
 * ao app com o erro na URL. Nada no app lia essa URL (GUPM-256), então a falha
 * sumia sem rastro. Este hook registra o erro na trilha, UMA vez.
 *
 * Montado uma única vez, na raiz (`App`). A deduplicação por `sessionStorage`
 * cobre remontagem (StrictMode, navegação) e recarregar a página com o mesmo
 * erro ainda na URL — que é o que acontece quando a pessoa aperta F5 na tela
 * de erro.
 *
 * Mostrar o erro na tela é o GUPM-256 — fora deste card.
 */

import { useEffect } from 'react';
import { extrairFalhaOAuth } from '@/domain/auditoria/eventos-app';
import { eventosApp } from '@/services/datasources/eventos-app';

const CHAVE = 'geoguard:falha-login-registrada';

function jaRegistrada(assinatura: string): boolean {
  try {
    return sessionStorage.getItem(CHAVE) === assinatura;
  } catch {
    return false;
  }
}

function marcarRegistrada(assinatura: string): void {
  try {
    sessionStorage.setItem(CHAVE, assinatura);
  } catch {
    // Storage bloqueado (aba privada, política do navegador): pior caso é
    // registrar de novo num F5 — melhor que não registrar.
  }
}

export function useRegistroDeRetornoDeLogin(): void {
  useEffect(() => {
    const falha = extrairFalhaOAuth(window.location.href);
    if (!falha) return;
    const assinatura = JSON.stringify(falha);
    if (jaRegistrada(assinatura)) return;
    marcarRegistrada(assinatura);
    void eventosApp.registrar('login_falha_provedor', falha);
  }, []);
}
